import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuUserComponent } from '../menu-user/menu-user.component';
import { AuthService } from '../../auth/services/auth.service';
import { WhatsappButtonComponent } from '../whatsapp-button/whatsapp-button.component';
@Component({
  selector: 'app-layout-user',
  standalone: true,
  imports: [RouterOutlet, MenuUserComponent, WhatsappButtonComponent],
  templateUrl: './layout-user.component.html',
  styleUrl: './layout-user.component.scss'
})
export class LayoutUserComponent {

  authService = inject(AuthService);

  ngOnInit(): void {
    this.authService.validateAuth().subscribe(response => {

    });
  }

}
